import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

const WHATSAPP_NUMBER = '96597970461';
const MESSAGE = "Hi TripSoul Travels! I'd like to plan a trip.";

export const WhatsAppButton = () => {
  const { t } = useLang();
  return (
  <a
    data-testid="whatsapp-button"
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(MESSAGE)}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
    className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 rounded-full bg-[#25D366] text-white shadow-lg shadow-green-500/30 pl-4 pr-5 py-3 hover:bg-[#1ebe5d] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping group-hover:hidden" />
    <MessageCircle className="w-6 h-6 relative" fill="currentColor" strokeWidth={0} />
    <span className="relative font-semibold text-sm hidden sm:inline">{t('chatWithUs')}</span>
  </a>
  );
};
